import { createContext } from 'react'

export const initialPage = ''

export const PageContext = createContext(initialPage)
